export default __webpack_public_path__ + "static/media/area-9.cb3637c1.jpg";